import lightGallery from 'lightgallery';

if ((typeof galleyItems !== 'undefined') && (typeof lightGalleryKey !== 'undefined')) {

    const $dynamicGallery = document.getElementById('blogPostLightGallery');

    $dynamicGallery.classList.add('hasGallery')

    const dynamicGallery = lightGallery($dynamicGallery, {
        licenseKey: lightGalleryKey,
        dynamic: true,
        dynamicEl: galleyItems,
    });

    $dynamicGallery.addEventListener('click', function () {
        console.log('rfgtrhytrjhtjy6t');
        dynamicGallery.openGallery();
    });
}


